import { SaphirParameter } from '../models/SaphirParameter';

export const formatExploitationTime = (param: SaphirParameter) => {
    const value = param.value;
    const hours = Number(value.substring(0, value.length - 2));
    const minutes = Number(value.substring(value.length - 2, value.length));
    return hours * 60 + minutes;
};
